import {FC} from 'react';
import clsx from 'clsx';
import {getRange} from 'utils/array';

type PaginationProps = {
    current?: number;
    length: number;
};

const Pagination: FC<PaginationProps> = ({current, length}) => (
    <div className="flex items-end">
        {getRange(1, length).map((page) => (
            <span
                key={page}
                className={clsx(
                    'mx-2 border-b-4 px-2',
                    current === page
                        ? 'border-green-700 font-semibold text-green-700'
                        : 'border-grey-300 text-transparent',
                )}
            >
                {current === page && page}
            </span>
        ))}
    </div>
);

export default Pagination;
